module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b82a774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ActivitiesPage.vue
// module id = 989
// module chunks = 0